import { usePageTitle } from '../hooks/usePageTitle';

/**
 * Shown while Auth0 resolves the session. Deliberately not `null` — a blank document is
 * indistinguishable from a crash, and this is exactly the phase where auth problems surface.
 */
export default function LoadingSplash() {
  usePageTitle('Signing in');
  return (
    <div className="not-configured" style={{ textAlign: 'center' }} data-testid="loading-splash">
      <h1 style={{ marginTop: 0 }}>bevi-ailab</h1>
      <p className="muted">Signing you in...</p>
    </div>
  );
}
